import { CHAT_EVENTS } from "../../constants/chat";
import { SCENE_EVENTS } from "../MVC/Model";
import { getVisibleNavigationMenuItems, isNavigationMenuEnabled } from "../engine/helpers/worldHelpers";

const escapeHtml = (value) => String(value ?? '')
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/"/g, '&quot;');

const itemTemplate = (entry) => {
  const isUrl = entry.type === 'url';
  const icon = isUrl ? 'open_in_new' : 'place';
  return `
  <li class='clickable location-menu-item' data-id="${escapeHtml(entry.id)}" data-type="${isUrl ? 'url' : 'room'}" data-target="${escapeHtml(entry.target || '')}">
    <span class="location-menu-item__label">${escapeHtml(entry.name)}</span>
    <span class="material-icons-outlined location-menu-item__icon">${icon}</span>
  </li>
`;
};

export class LocationMenu {
  constructor({ model }) {
    this.model = model;
    this.container = $('#locationMenu');
    this.toggleMenu = $('#location_name');
    this.compassTriggers = $('.icon-compass, #locationsButton');
    this.opened = false;

    this.model.addEventListener(SCENE_EVENTS.TOGGLE_LOCATION_MENU, () => {
      if (!this.isEnabled()) return;
      if (!this.opened) {
        this.open();
      } else {
        this.close();
      }
    });

    this.toggleMenu.on("click", () => {
      if (!this.isEnabled()) return;
      if (!this.opened) {
        this.open();
      } else {
        this.close();
      }
    });

    this.close = () => {
      this.opened = false;
      this.container.removeClass('is-active');
    };

    this.open = () => {
      if (!this.isEnabled()) return;
      this.opened = true;
      this.container.addClass('is-active');
      updateMenuItemPosition();
      this.updateActiveState();
      let toggleRect;
      const $locationCompass = $('.world-bottom-nav__area__location .icon-compass');
      if ($locationCompass.is(':visible') && $locationCompass[0]) {
        toggleRect = $locationCompass[0].getBoundingClientRect();
      } else if ($('#locationsButton')[0]) {
        toggleRect = $('#locationsButton')[0].getBoundingClientRect();
      }
      if (toggleRect) {
        this.container.css('left', `${toggleRect.left}px`);
      }
    };

    $("#css3d").on("click", this.close);
    $("#tuneMenu").on("click", this.close);
    $("#people-list-icon-button").on("click", this.close);
    $(document).on('click', '.world-bottom-nav__area__location .icon-info', this.close);
    $("#burger-menu").on("click", this.close);
    model.addEventListener(CHAT_EVENTS.OPEN, this.close);

    const updateMenuItemPosition = () => {
      const toggle = document.querySelector('.world-bottom-nav__area__location__name');
      const menuItem = document.querySelector('#locationMenu');

      if (toggle && menuItem) {
        const toggleRect = toggle.getBoundingClientRect();
        menuItem.style.left = `${toggleRect.left}px`;
      }
      $('#tuneMenu').removeClass('is-active');
    };

    updateMenuItemPosition();
    window.addEventListener('resize', updateMenuItemPosition);

    this.container.on('click', '.location-menu-item', (e) => {
      const $item = $(e.currentTarget);
      const type = $item.data('type');
      const target = String($item.data('target') || '');
      if (type === 'url') {
        if (target) {
          window.location.href = target;
        }
        this.close();
        return;
      }
      if (!target) return;
      this.model.nextSceneId = target;
      this.model.customSceneChange({
        element: this.model.view?.cameraPointingMesh,
      });
      this.close();
    });

    this.render();
    this.close();
  }

  isEnabled() {
    return isNavigationMenuEnabled(this.model.sceneData);
  }

  applyCompassState() {
    const enabled = this.isEnabled();
    this.compassTriggers.toggleClass('disabled', !enabled);
    if (!enabled) {
      this.close();
    }
  }

  render() {
    this.container.empty();
    this.applyCompassState();

    if (!this.isEnabled()) {
      return;
    }

    const titleItem = $(`
      <li class="tune-menu-title location-menu-title">
        <span data-lang="location-menu-navigation-title">${$trans('location-menu-navigation-title') || 'Navigation'}</span>
      </li>
    `);
    this.container.append(titleItem);

    const items = getVisibleNavigationMenuItems(this.model.sceneData);
    items.forEach((entry) => {
      this.container.append($(itemTemplate(entry)));
    });
  }

  updateActiveState() {
    const currentScene = this.model.currentScene;
    const currentId = currentScene?.id != null ? String(currentScene.id) : '';
    const liElements = this.container.find('li.location-menu-item');

    liElements.removeClass('active');
    liElements.each((_, element) => {
      const $el = $(element);
      if ($el.data('type') !== 'room') return;
      if (String($el.data('target') || '') === currentId) {
        $el.addClass('active');
      }
    });
  }

  static template() {
    return `<ul class='bagless-dropdown-menu' id='locationMenu'></ul>`
  }
}
